import { UserGroup, User} from "src/types/users";

export const sortOptions = [
  { label: "Created date", value: "createdDate" },
  { label: "Last updated", value: "modifiedDate" },
];

export enum streamAccessEntityTypes  {
  USER = "user",
  USER_GROUP = "userGroup", 
}

export interface IRecordItem {
  entityType: string;
  userGroup?: UserGroup;
  user?: User;
  groupRead: boolean;
  groupWrite: boolean;
  read: boolean;
  write: boolean;
}

export interface IUpdateAccess {
  id?:string | null,
  readAll?: boolean | null,
  userGroups?: IRecordItem[] | null,
  users?: IRecordItem[] | null,
  writeAll?: boolean | null,
  readAllSet?: boolean | null,
  writeAllSet?: boolean,
}
